module.exports = __webpack_public_path__ + "img/contact-alexanderhammarberg.a9a97edb.png";